<template>
	<section class="section hub-featured" v-if="results && computedPayload.visible">
		<div class="container mx-auto px-4">

			<div class="featured-programme-course__cards">
				<div class="featured-programme-course-container">
					<div class="featured-programme-course featured-programme-course-featured" data-id="">
						<div class="client-logo-container"><img class="client-logo" :src="$filters.analyseImage(featured['logo'],'logosm','logoxl')" width="54" height="54" :alt="`${featured['institution']}`" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'"></div>
						<div class="featured-programme-course__header" :style="`background-image: url(${$filters.analyseImage(featured['cover-image'],'herosearchxs','herosearchsm')});`">
							<span class="pill bg-blue-light">{{ isOnline }}</span>
						</div>
						<div class="featured-programme-course__wrapper"><a :href="computedLink">
								<div class="featured-programme-course__body">
									<h4 class="featured-programme-course__body-title"><span>{{ featured['title'] }}</span></h4>
									<p class="featured-programme-course__body-text">{{ featured['summary'] }}</p>
								</div>
								<div class="featured-programme-course__footer">
									<div class="featured-programme-course__footer-item">
										<div class="icon-wrapper">
											<img class="icon" :src="`/images/icons/icon-clock--blue.svg?${$config.version}`" alt="Clock" loading="lazy">
										</div>
										<span v-if="featured['date-start']">{{ $filters.ukDateShort(featured['date-start']) }}</span>
										<span v-if="featured['prog-length']">
											<span v-if="featured['date-start']">&nbsp;-</span>
											{{ featured['prog-length'] }}
										</span>
									</div>
									<div class="featured-programme-course__footer-item">
										<div class="icon-wrapper">
											<img class="icon" :src="`/images/icons/icon-book--yellow.svg?${$config.version}`" alt="Book" loading="lazy">
										</div>
										{{ featured['esc-route'][0] }}
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>

		</div>
	</section>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
    name: 'HubFeaturedProgrammeCourse',

    props: {
      payload: {
        type: [Object,String]
      }
    },

		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'prog-course-dev' : 'prog-course-live',
				searchObject: {
					hitsPerPage: 1,
					facets: ["slug"],
					facetFilters: []
				},
				results: false
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

      console.log('HUBPAGE:FEATURED:', this.computedPayload);
      // Set facetFilters from payload slug.
      this.searchObject.facetFilters.push([`slug:${this.computedPayload.slug}`]);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("featured programme or course search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		},

    methods: {
			calculated_img(item,index) {
				if (item.image !== "") {
					return 'background-image: url('+item.image+');';
				}
				return 'background-image: url(/images/collections/collection-bg-'+(index+1)+'.jpg?'+this.$config.version+');';
			}
		},

		computed: {
      computedPayload() {
        return typeof this.payload === 'string' ? JSON.parse(this.payload) : this.payload;
      },
			featured() {
				return this.results[0];
			},
			isOnline() {
        return this.featured['online'] ? 'Online' : this.featured['location-text'];
      },
			computedLink() {
				let prefix = (this.featured['prog-or-course'] == "Course") ? 'course' : 'programme';
				return '/'+prefix+'/'+this.featured['slug'];
			}
		}
	}
</script>
